module.exports = __webpack_public_path__ + "fonts/intelo-italic.0ddbc8a.woff";